import React from 'react';
import PropTypes from 'prop-types';

export const ArrowUp = ({ width, height, ...props }) => (
  <svg
    data-icon='arrow-up'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='m12 10.8-4.6 4.6L6 14l6-6 6 6-1.4 1.4-4.6-4.6Z'
    />
  </svg>
);

ArrowUp.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

ArrowUp.defaultProps = {
  width: 24,
  height: 24,
};
